// Private-layout content inset. TOPBAR_OFFSET clears the fixed topbar; GUTTER is
// the grey padding on the sides and bottom. Defined once here so the layout and
// any full-bleed page that cancels the inset stay in sync (see
// PrivateLayout.js and Pages/HealthSafety/SafetyDocumentsPage.js).
export const LAYOUT_TOPBAR_OFFSET = 90;
export const LAYOUT_CONTENT_GUTTER = 20;
